import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ClinicPageContent } from '@/features/clinic-page/components';

const searchSchema = z.object({
  // Stripe's, when the embedded checkout returns here.
  session_id: z.string().optional(),
  // Stripe Connect's, when their account setup returns here.
  stripe: z.string().optional(),
});

/**
 * PUBLIC: the one link a new clinic is sent to sign, pay and get set up.
 * The signed token in the path is the credential; there is no login yet.
 */
export const Route = createFileRoute('/start/$token')({
  validateSearch: searchSchema,
  component: ClinicStartPage,
});

function ClinicStartPage() {
  const { token } = Route.useParams();
  const { session_id } = Route.useSearch();
  return (
    <>
      <title>Your Borrah setup</title>
      {/* Keep this page out of search indexes: the URL IS the credential. */}
      <meta name="robots" content="noindex, nofollow" />
      <ClinicPageContent token={token} sessionId={session_id ?? null} />
    </>
  );
}
